import palette from '../palette';

export default {
  styleOverrides: {
    indicator: {
      backgroundColor: palette.secondary.main,
    },
  },
};
